module.exports = __webpack_public_path__ + "static/media/celebracion.f52dee67.png";